export default "__VITE_ASSET__DfOUJROs__"